import _ from "lodash-contrib";
import CustomerHistoryPatternsHeader from "./CustomerHistoryPatternsHeader";
import ReportPageService from "../../service/ReportPageService";

const CustomerHistoryPatternsTable = ({ patterns, displayedAttributes, totalSlots }) => {
  return (
    <table className="config-table-double">
      <thead>
      <tr>
        {displayedAttributes.map((attr, i) => (
          <th key={i}>
            <CustomerHistoryPatternsHeader attribute={attr} />
          </th>
        ))}
      </tr>
      </thead>

      <tbody>
      {patterns.map((p, rowIndex) => (
        <tr key={rowIndex}>
          {displayedAttributes.map((attr, colIndex) => (
            <td key={colIndex} className="use-mono-font">
              {(() => {
                const value = _.get(p, attr);

                // --- Custom computed attribute ---
                if (attr === "relevance") {
                  const slotsValid = p.slotsValid ?? 0;
                  const percent = (slotsValid / totalSlots) * 100;
                  return `${percent.toFixed(2)}%`;
                }

                // --- dominantHour handling ---
                if (attr === "dominantHour") {
                  if (value == null) return "-";
                  return `${ReportPageService.renderPrettyValue(value)}:00`;
                }

                return ReportPageService.renderPrettyValue(value);
              })()}
            </td>
          ))}
        </tr>
      ))}
      </tbody>
    </table>
  );
};

export default CustomerHistoryPatternsTable;
